import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Log API configuration on startup
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800';
console.log('='.repeat(80));
console.log('🚀 JIMS MOWING APP STARTING');
console.log(`📡 API Server: ${API_BASE_URL}`);
console.log(`🔥 Firebase Project: ${process.env.REACT_APP_FIREBASE_PROJECT_ID || 'Not configured'}`);
console.log('='.repeat(80));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
